export default __webpack_public_path__ + "static/media/hand-paper-wht.a0a3017b.svg";